import { SupportV2CountVerificationStatus } from "@redotech/cockroachdb-codegen/tables/support-v2-count-verification-status";

/** Absolute ticket-count slack used to GATE migration status (wired activity). */
export const COUNT_MATCH_TOLERANCE = 10;

/**
 * Relative slack (percent) recorded as an EXTRA signal alongside the absolute
 * gate above. It does not change how migrations are gated — it surfaces the
 * "within 5%" view the team asked for so large teams (where ±10 is noise) and
 * tiny teams (where ±10 is 200% slack) both get a meaningful read.
 */
export const COUNT_MATCH_PERCENT_TOLERANCE = 5;

/**
 * Relative difference of v2 vs the v1 baseline, as a percent. `null` when v1 is
 * 0 but v2 is not (the ratio is undefined — JSON can't carry Infinity); 0 when
 * both are 0.
 */
export function relativePercentDifference(
  v1Count: number,
  v2Count: number,
): number | null {
  if (v1Count === 0) {
    return v2Count === 0 ? 0 : null;
  }
  return (Math.abs(v2Count - v1Count) / v1Count) * 100;
}

/** Whether v2 is within `percentTolerance`% of the v1 baseline. */
export function withinPercentTolerance(
  v1Count: number,
  v2Count: number,
  percentTolerance: number = COUNT_MATCH_PERCENT_TOLERANCE,
): boolean {
  if (v1Count === 0) {
    return v2Count === 0;
  }
  return (Math.abs(v2Count - v1Count) / v1Count) * 100 <= percentTolerance;
}

export const MIGRATION_TEAM_STATUS_VALUES = [
  "not_started",
  "in_progress",
  "completed",
  "completed_with_failures",
  "count_mismatch",
  "failed",
  "flag_enabled",
] as const;

// Derived from the DB enum — not hand-mirrored.
export const COUNT_VERIFICATION_STATUS_VALUES = Object.values(
  SupportV2CountVerificationStatus,
) as [
  SupportV2CountVerificationStatus.Pending,
  SupportV2CountVerificationStatus.WithinTolerance,
  SupportV2CountVerificationStatus.CountMismatch,
  SupportV2CountVerificationStatus.Error,
];
